import type { RoleCode } from '../api/contrat.js';
import { cheminEcran, peutOuvrir } from './ecrans.js';

/**
 * Onglets du dossier, comme la démo (/dossiers/:id/…) : les écrans qui ne s'ouvrent que sur un dossier désigné par `?dossier=`.
 * Sans dossier ouvert, la coquille ajoute au-dessus de l'écran un renvoi vers la liste des dossiers et « Nouveau dossier »
 * (jamais de cul-de-sac) ; ces écrans ne figurent pas dans le menu.
 */
export const ECRANS_DU_DOSSIER: readonly string[] = ['D04', 'D04b', 'D04c', 'D05', 'D15', 'D17'];

/** Écrans du dossier qui portent la barre d'onglets de la coquille (D03 porte la sienne, dans sa vue d'ensemble). */
export const ECRANS_AVEC_ONGLETS: readonly string[] = [...ECRANS_DU_DOSSIER, 'D06', 'D08', 'D09'];

export interface OngletDossier {
  /** Clé unique de l'onglet (plusieurs onglets peuvent ouvrir le même écran, D03 et ses sous-vues). */
  cle: string;
  /** Écran ouvert par l'onglet (droit d'accès, onglet courant). */
  id: string;
  libelle: string;
  chemin: string;
}

/** `vue` : sous-vue de D03 (`&vue=`), comme les onglets du dossier de la démo (PARITE-4). */
const ONGLETS: readonly { id: string; libelle: string; vue?: string }[] = [
  { id: 'D03', libelle: 'Vue d’ensemble' },
  { id: 'D17', libelle: 'Démarrage guidé' },
  { id: 'D04', libelle: 'Arbre et tableaux' },
  { id: 'D05', libelle: 'Héritiers' },
  { id: 'D03', libelle: 'Import de contacts', vue: 'import-contacts' },
  { id: 'D15', libelle: 'Biens et titres' },
  { id: 'D03', libelle: 'Actes notariés', vue: 'actes' },
  { id: 'D09', libelle: 'Documents' },
  { id: 'D03', libelle: 'Vidéos', vue: 'videos' },
  { id: 'D06', libelle: 'Messages' },
  { id: 'D08', libelle: 'Facturation' },
  { id: 'D04c', libelle: 'Estimation' },
  { id: 'D03', libelle: 'Comptes rendus', vue: 'comptes-rendus' },
  { id: 'D03', libelle: 'Journal', vue: 'journal' },
];

const requete = (chemin: string): URLSearchParams => new URLSearchParams(chemin.split('#', 1)[0]?.split('?')[1] ?? '');

/** Dossier ouvert, désigné par `?dossier=` dans l'adresse (vide : aucun). */
export function dossierDeLAdresse(chemin: string): string | null {
  const id = requete(chemin).get('dossier')?.trim();
  return id ? id : null;
}

/** Onglets que le rôle peut ouvrir, chacun gardant le dossier courant. */
export function ongletsDossier(role: RoleCode, idDossier: string): OngletDossier[] {
  return ONGLETS.filter((o) => peutOuvrir(role, o.id)).map((o) => ({
    cle: o.vue ? `${o.id}:${o.vue}` : o.id,
    id: o.id,
    libelle: o.libelle,
    chemin: `${cheminEcran(o.id)}?dossier=${encodeURIComponent(idDossier)}${o.vue ? `&vue=${o.vue}` : ''}`,
  }));
}
